import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import styled from 'styled-components'
import { useMutation } from '@apollo/react-hooks'
import { feedbackMutations } from '../../graphql/mutations'
import { useSnackbar } from 'notistack'

const DialogWrapper = styled.div`
    margin: 20px;
`

const CommentModal = ({ isOpen, onClose, moduloId, cursoId, conteudoId, trilhaId, refetchComment, changeComment, errorComment, comment, commentData, setComment, lastComment }) => {

  const [formTouched, setFormTouched] = useState(false)
  const { enqueueSnackbar } = useSnackbar()

  const [adicionarComentario] = useMutation(feedbackMutations.ADD_COMMENT, {
    onCompleted() {
      onClose()
    },

  })




  const handleSubmit = e => {
    e.preventDefault()
    setFormTouched(true)
    if (comment) {
      return adicionarComentario({
        variables: {
          descricao: comment,
          modulo_id: moduloId,
          conteudo_id: conteudoId,
          trilha_id: trilhaId,
          curso_id: cursoId
        }
      })
    }
    if (adicionarComentario) {
      enqueueSnackbar('Preencha o campo corretamente.')
    } else {
      onClose()
    }
  }


  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={'md'}
        style={{ padding: '25px' }}
      >
        <form onSubmit={handleSubmit}>
          <DialogWrapper>
            <DialogTitle id="alert-dialog-title">
              <Typography variant={"h4"} component={"h1"} style={{ fontWeight: 300 }}>Diga-nos o que achou deste conteúdo.</Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <TextField
                  id="comment"
                  label="Comentário"
                  error={!!errorComment && !!formTouched}
                  placeholder="Escreva um comentário..."
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                  variant="outlined"
                  onChange={changeComment}
                  name="comment"
                  multiline={true}
                  rows={10}
                  helperText={(!!errorComment && !!formTouched) ? 'Campo obrigatório' : ''}
                  value={comment}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                cancelar
              </Button>
              <Button type={'submit'} color="primary" autoFocus>
                comentar
              </Button>
            </DialogActions>
          </DialogWrapper>
        </form>
      </Dialog>
    </div>
  );
}
export default CommentModal